
var popoverLess = {};
import genaration from '../../utils/classname';
export var popoverClass = genaration(popoverLess, 'popover');